import type { ConsecutiveSearchItemSelectionPayload, FetchVersionsForSearchPayload, LoadCurrentItemMetadataPayload, LoadItemMetadataPayload, LoadItemMetadataResult, OpenItemByIdPayload, OpenItemPayload, SetItemPageItemPayload, SingleItemSearchPayload, StoreDoUploadPayload, ToggleSearchItemSelectionPayload, UpdateSearchHitWithMediaPayload, UploadItemFilesPayload } from "@mimir/web/store/storePayloads";
import { getGlobalStore } from '@mimir/web/store/index';

export async function storeDispatchDoUpload(payload: StoreDoUploadPayload) {
  return await getGlobalStore().dispatch('doUpload', payload);
}

export async function storeDispatchToggleSearchItemSelection(payload: ToggleSearchItemSelectionPayload): Promise<void> {
  return await getGlobalStore().dispatch('toggleSearchItemSelection', payload);
}

export async function storeDispatchOpenItem(payload: OpenItemPayload): Promise<void> {
  return await getGlobalStore().dispatch('openItem', payload);
}

export async function storeDispatchFetchVersionsForSearch(payload: FetchVersionsForSearchPayload): Promise<void> {
  return await getGlobalStore().dispatch('fetchVersionsForSearch', payload);
}

export async function storeDispatchConsecutiveSearchItemSelection(payload: ConsecutiveSearchItemSelectionPayload): Promise<void> {
  return await getGlobalStore().dispatch('consecutiveSearchItemSelection', payload);
}

export async function storeDispatchLoadItemMetadata(payload: LoadItemMetadataPayload): Promise<LoadItemMetadataResult | null> {
  return await getGlobalStore().dispatch('loadItemMetadata', payload);
}

export async function storeDispatchLoadCurrentItemMetadata(payload: LoadCurrentItemMetadataPayload): Promise<LoadItemMetadataResult | null> {
  return await getGlobalStore().dispatch('loadCurrentItemMetadata', payload);
}

export async function storeDispatchSetItemPageItem(payload: SetItemPageItemPayload): Promise<void> {
  return await getGlobalStore().dispatch('setItemPageItem', payload);
}

export async function storeDispatchSingleItemSearch(payload: SingleItemSearchPayload): Promise<void> {
  return await getGlobalStore().dispatch('singleItemSearch', payload);
}

export async function storeDispatchUpdateSearchHitWithMedia(payload: UpdateSearchHitWithMediaPayload): Promise<void> {
  return await getGlobalStore().dispatch('updateSearchHitWithMedia', payload);
}

export async function storeDispatchOpenItemById(payload: OpenItemByIdPayload): Promise<void> {
  return await getGlobalStore().dispatch('openItemById', payload);
}

export async function storeDispatchUploadItemFiles(payload: UploadItemFilesPayload): Promise<void> {
  return await getGlobalStore().dispatch('uploadItemFiles', payload);
}
